/* ══════════════════════════════════════════════════════════════════════════
   Shard House — Release Teaser · Cinematic Entry Flow
   ══════════════════════════════════════════════════════════════════════════
   Submits the customer form into a hidden iframe so Shopify handles
   it natively (including CAPTCHA tokens) without redirecting the page.
   Waits for the iframe response before playing the cinematic transition.
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
    'use strict';

    document.querySelectorAll('.sh-teaser__form').forEach(function (form) {
        var wrap = form.closest('.sh-teaser__form-wrap');
        if (!wrap) return;

        var section = wrap.closest('.sh-teaser');
        var entryEl = wrap.querySelector('.sh-teaser__entry');
        var fieldEl = wrap.querySelector('.sh-teaser__field');
        var microEl = wrap.querySelector('.sh-teaser__micro');
        var errorEl = wrap.querySelector('.sh-teaser__error');

        if (!entryEl) return;

        /* Create a hidden iframe to absorb the form submission */
        var iframeName = 'sh-teaser-sink-' + Math.random().toString(36).slice(2, 8);
        var iframe = document.createElement('iframe');
        iframe.name = iframeName;
        iframe.setAttribute('aria-hidden', 'true');
        iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none;';
        wrap.appendChild(iframe);

        /* Point the form at the hidden iframe */
        form.setAttribute('target', iframeName);

        /* ── Cinematic transition choreography ── */
        function playSuccessTransition() {
            /* Advance house state to insider */
            if (window.shHouse) window.shHouse.advance('insider');

            var overline = section && section.querySelector('.sh-teaser__overline');
            var title = section && section.querySelector('.sh-teaser__title');
            var rule = section && section.querySelector(':scope > .sh-teaser__inner > .sh-teaser__rule');
            var body = section && section.querySelector('.sh-teaser__body');
            var context = [overline, title, rule, body];

            /* Phase 1: Fade out form + dim surroundings (0–600ms) */
            if (fieldEl) fieldEl.classList.add('sh-teaser--exiting');
            if (microEl) microEl.classList.add('sh-teaser--exiting');
            context.forEach(function (el) {
                if (el) el.classList.add('sh-teaser--dimmed');
            });

            /* Phase 2: Crossfade — hide form, reveal entry (700ms) */
            setTimeout(function () {
                form.style.height = form.offsetHeight + 'px';
                form.style.overflow = 'hidden';

                requestAnimationFrame(function () {
                    form.style.transition = 'height 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease';
                    form.style.opacity = '0';
                    form.style.height = '0px';
                });

                entryEl.classList.add('sh-teaser__entry--visible');

                context.forEach(function (el) {
                    if (el) {
                        el.classList.add('sh-teaser--restoring');
                        el.classList.remove('sh-teaser--dimmed');
                    }
                });

                /* Phase 3: Continue CTA (after 2s from reveal) */
                var continueBtn = entryEl.querySelector('.sh-teaser__continue');
                if (continueBtn) {
                    setTimeout(function () {
                        continueBtn.classList.add('sh-teaser__continue--visible');
                    }, 2000);
                }
            }, 700);
        }

        function showError(message) {
            if (errorEl) {
                errorEl.textContent = message;
                errorEl.style.display = '';
            }
            /* Re-enable form */
            var btn = form.querySelector('.sh-teaser__cta');
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || btn.textContent; }
            var input = form.querySelector('.sh-teaser__input');
            if (input) input.disabled = false;
        }

        form.addEventListener('submit', function (e) {
            var input = form.querySelector('.sh-teaser__input');
            if (!input || !input.value || !input.validity.valid) {
                e.preventDefault();
                input && input.focus();
                return;
            }

            /* Let the form submit natively into the iframe — do NOT preventDefault */

            /* Clear any previous error */
            if (errorEl) errorEl.style.display = 'none';

            /* Disable form while processing */
            var btn = form.querySelector('.sh-teaser__cta');
            if (btn) { btn.dataset.originalText = btn.textContent; btn.disabled = true; }
            input.disabled = true;

            /* Listen for iframe response to determine success/failure */
            var handled = false;
            var timeout = setTimeout(function () {
                if (handled) return;
                handled = true;
                /* After 8s with no response, assume success (network may be slow) */
                playSuccessTransition();
            }, 8000);

            iframe.addEventListener('load', function onLoad() {
                if (handled) return;
                handled = true;
                clearTimeout(timeout);
                iframe.removeEventListener('load', onLoad);

                /* Give Shopify a moment to finalize the redirect in the iframe */
                setTimeout(function () {
                    try {
                        var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                        var iframeUrl = iframe.contentWindow.location.href;
                        var bodyText = iframeDoc.body ? iframeDoc.body.innerHTML : '';

                        /* Shopify redirects to /challenge if CAPTCHA failed */
                        if (iframeUrl.indexOf('/challenge') !== -1) {
                            showError('Verification failed. Please try again.');
                            return;
                        }

                        /* Check for Shopify error indicators in response */
                        var errorList = iframeDoc.querySelector('.errors, #error_message, [data-error]');
                        if (errorList) {
                            var msg = errorList.textContent.trim();
                            if (msg.toLowerCase().indexOf('already') !== -1 || msg.toLowerCase().indexOf('taken') !== -1) {
                                /* Email already registered — treat as success */
                                playSuccessTransition();
                            } else {
                                showError(msg || 'Something went wrong. Please try again.');
                            }
                            return;
                        }

                        /* No errors detected — success */
                        playSuccessTransition();
                    } catch (err) {
                        /* Cross-origin restriction — can't read iframe. Assume success */
                        playSuccessTransition();
                    }
                }, 500);
            });
        });
    });
})();
